import { render, staticRenderFns } from "./InfoPubNoNew.vue?vue&type=template&id=78343205&scoped=true"
import script from "./InfoPubNoNew.vue?vue&type=script&lang=js"
export * from "./InfoPubNoNew.vue?vue&type=script&lang=js"
import style0 from "./InfoPubNoNew.vue?vue&type=style&index=0&id=78343205&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78343205",
  null
  
)

export default component.exports